const carouselItems = [
  {
    title: '年度巨献：2025娱乐圈十大塌房事件全回顾',
    excerpt: '从顶流失德到网红翻车，这一年娱乐圈的瓜一个比一个大。我们为你精心整理了年度最劲爆的十大塌房事件。',
    tag: '年度专题',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20abstract%20composition%20with%20collapsed%20geometric%20shapes%20in%20warm%20red%20and%20coral%20tones%2C%20fragmented%20design%20elements%2C%20editorial%20magazine%20cover%20style%2C%20bold%20dynamic%20visual%2C%20modern%20graphic%20design%2C%20dramatic%20lighting%2C%20cream%20background%20with%20vibrant%20accents&width=1200&height=700&seq=carousel-01-chigua&orientation=landscape'
  },
  {
    title: '深度调查：网红经济的灰色产业链大揭秘',
    excerpt: '从刷量造假到数据注水，从人设包装到流量买卖。我们深入调查了网红经济背后不为人知的灰色操作。',
    tag: '深度调查',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20investigative%20journalism%20visual%20with%20magnifying%20glass%20effect%20over%20digital%20elements%2C%20warm%20coral%20and%20cream%20color%20scheme%2C%20modern%20editorial%20design%2C%20geometric%20patterns%2C%20professional%20investigation%20aesthetic%2C%20clean%20composition&width=1200&height=700&seq=carousel-02-chigua&orientation=landscape'
  },
  {
    title: '独家整理：选秀节目那些不为人知的潜规则',
    excerpt: '多位业内人士匿名爆料，揭露选秀节目从海选到成团背后的资本博弈和暗箱操作。',
    tag: '独家揭秘',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20stage%20performance%20visual%20with%20dramatic%20spotlight%20effects%20and%20shadow%20elements%2C%20warm%20red%20and%20golden%20tones%2C%20theater%20atmosphere%2C%20editorial%20design%20style%2C%20geometric%20abstract%20composition%2C%20professional%20broadcast%20aesthetic&width=1200&height=700&seq=carousel-03-chigua&orientation=landscape'
  },
  {
    title: '直播带货翻车名场面TOP20，每一帧都是教科书',
    excerpt: '从产品翻车到言论失误，我们盘点了直播带货史上最令人啼笑皆非的翻车现场。',
    tag: '趣味盘点',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20streaming%20studio%20visual%20with%20colorful%20product%20displays%20and%20dramatic%20lighting%20effects%2C%20warm%20coral%20and%20cream%20tones%2C%20editorial%20design%2C%20modern%20ecommerce%20aesthetic%2C%20geometric%20composition%2C%20playful%20yet%20professional&width=1200&height=700&seq=carousel-04-chigua&orientation=landscape'
  },
  {
    title: '合约纠纷全纪实：明星与经纪公司的爱恨情仇',
    excerpt: '从练习生合同到天价违约金，我们梳理了近三年娱乐圈最轰动的合约纠纷案例。',
    tag: '法律视角',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20legal%20document%20visual%20with%20geometric%20contract%20elements%20and%20dramatic%20shadow%20effects%2C%20warm%20coral%20and%20cream%20tones%2C%20editorial%20design%2C%20professional%20legal%20aesthetic%2C%20modern%20graphic%20composition&width=1200&height=700&seq=carousel-05-chigua&orientation=landscape'
  },
  {
    title: '私生饭事件簿：那些被跟踪骚扰的明星们',
    excerpt: '私生饭问题日益严重，我们整理了多起引发社会关注的明星被跟踪骚扰事件。',
    tag: '社会关注',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20privacy%20invasion%20visual%20with%20shadow%20figures%20and%20protective%20barrier%20elements%2C%20warm%20coral%20and%20cream%20tones%2C%20editorial%20design%2C%20mysterious%20atmosphere%2C%20modern%20graphic%20composition%2C%20geometric%20abstract%20style&width=1200&height=700&seq=carousel-06-chigua&orientation=landscape'
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-2">重磅爆料</h2>
        <p className="text-sm text-foreground-500 mb-8">网红吃瓜网站深度专题策划，全网独家重磅内容</p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.map((item, idx) => (
            <div key={idx} className="rounded-lg overflow-hidden bg-background-100 border border-background-200/60 hover:border-primary-200/60 transition-colors cursor-pointer group flex flex-col">
              <div className="relative aspect-[16/9] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  onError={(e) => {
                    const t = e.currentTarget;
                    t.style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <span className="absolute bottom-3 left-3 px-2.5 py-1 rounded text-xs font-medium bg-accent-500 text-background-50">{item.tag}</span>
              </div>
              <div className="p-4 flex flex-col flex-1">
                <h3 className="text-sm font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.excerpt}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}